import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import store from '@/store/index.js'
import personalAPI from '@/api/personal'
import { getUnisysid } from '@/utils/utils'
import system from '@/api/system'
import otherAPI from '@/api/other'


const UniLogin = () => import('../views/login/UniLogin')
const UniWebLogin = () => import('../views/login/UniWebLogin')
const Index = () => import('../views/index/Index')
const Home = () => import('../views/home/Home')
// * 音乐相关页面
const PureMusic = () => import('../views/music/PureMusic')
const VoiceMusic = () => import('../views/music/VoiceMusic')

// * 图片生成相关页面
const TextToImage = () => import('../views/image/TextToImage')
const ImageToImage = () => import('../views/image/ImageToImage')
const ImageDetails = () => import('../views/image/ImageDetails')

// // * 视频生成相关页面
// const VideoGenerate = () => import('../views/video/VideoGenerate')

// // * 数字人相关页面
// const DigitalHuman = () => import('../views/digital-human/DigitalHuman')

// // * 智能对话相关页面
const ChatBot = () => import('../views/chat/ChatBot')

// // * 智能体应用
// const AgentMarket = () => import('../views/agent/AgentMarket')
// const AgentDetail = () => import('../views/agent/AgentDetail')

// * 记录相关页面
const GenerateRecords = () => import('../views/record/Generate')
const FavoriteRecords = () => import('../views/record/Favorite')
const DownloadRecords = () => import('../views/record/Download')
const MusicPlayerDemo = () => import('../views/music/MusicPlayerDemo')
const ContentNotFound = () => import('../views/basic/ContentNotFound')
const NotFound = () => import('../views/basic/NotFound')

Vue.use(VueRouter)

const routes = [
    {
        path: '',
        redirect: '/index'
    },
    {
        path: '/uni_login',
        name: 'UniLogin',
        component: UniLogin
    },
    {
        path: '/uni_web_login',
        name: 'UniWebLogin',
        component: UniWebLogin
    },
    {
        path: '/index',
        name: 'Index',
        component: Index,
        // redirect: '/home',
        // redirect: '/voice_music',
        children: [
            // {
            //     // path: '/home',
            //     // name: 'Home',
            //     // component: Home,
            //     path: '/voice_music',
            //     name: 'VoiceMusic',
            //     component: VoiceMusic,
            //     children: [
            {
                path: '/voice_music',
                name: 'VoiceMusic',
                component: VoiceMusic,
                meta: { title: '人声歌曲', breadcrumb: true }
            },
            {
                path: '/pure_music',
                name: 'PureMusic',
                component: PureMusic,
                meta: { title: '纯音乐', breadcrumb: true }
            },
            {
                path: '/text_to_image',
                name: 'TextToImage',
                component: TextToImage,
                meta: { title: '文生图', breadcrumb: true }
            },
            {
                path: '/image_to_image',
                name: 'ImageToImage',
                component: ImageToImage,
                meta: { title: '图生图', breadcrumb: true }
            },
            {
                path: '/image_details',
                name: 'ImageDetails',
                component: ImageDetails,
                meta: { title: '图片详情', breadcrumb: true }
            },
            // {
            //     path: '/video_generate',
            //     name: 'VideoGenerate',
            //     component: VideoGenerate,
            //     meta: { title: '视频生成', breadcrumb: true }
            // },
            // {
            //     path: '/digital_human',
            //     name: 'DigitalHuman',
            //     component: DigitalHuman,
            //     meta: { title: '数字人', breadcrumb: true }
            // },
            {
                path: '/chat',
                name: 'ChatBot',
                component: ChatBot,
                meta: { title: '智能对话', breadcrumb: true }
            },
            // {
            //     path: '/agent_market',
            //     name: 'AgentMarket',
            //     component: AgentMarket,
            //     meta: { title: '智能体应用', breadcrumb: true }
            // },
            // {
            //     path: '/agent_detail',
            //     name: 'AgentDetail',
            //     component: AgentDetail,
            //     meta: { title: '智能体详情', breadcrumb: true }
            // },
            {
                path: '/generate_records',
                name: 'GenerateRecords',
                component: GenerateRecords,
                meta: { title: '生成记录', breadcrumb: true }
            },
            {
                path: '/favorite_records',
                name: 'FavoriteRecords',
                component: FavoriteRecords,
                meta: { title: '收藏记录', breadcrumb: true }
            },
            {
                path: '/download_records',
                name: 'DownloadRecords',
                component: DownloadRecords,
                meta: { title: '下载记录', breadcrumb: true }
            },
            {
                path: '/play',
                name: 'MusicPlayerDemo',
                component: MusicPlayerDemo,
                meta: { title: '音乐播放器', breadcrumb: true }
            },
            {
                path: '/not_found',
                name: 'ContentNotFound',
                component: ContentNotFound,
                meta: { title: '内容不存在', breadcrumb: false }
            },

            //     ]
            // },
        ]
    },
    // 404页面配置
    {
        path: '/404',
        name: '404',
        component: NotFound,
        meta: { title: '404' }
    },
    {
        path: '*',
        redirect: '/404',
        meta: { title: '404' }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

router.beforeEach(async (to, from, next) => {
    getUnisysid()

    let routerList = ['/uni_login', '/uni_web_login']

    const getVi = to.query.getVi
    const storedVisitorRes = VueCookies.get('visitorRes')
    const storedVisitorData = storedVisitorRes || null

    async function fetchAndStoreVisitorInfo(params) {
        const visitorRes = await personalAPI.getVisitorInfoAPI(params)

        if (visitorRes.code !== 200 || !visitorRes.data) {
            return null
        }

        const visitorData = { ...visitorRes.data }

        VueCookies.set('visitorRes', visitorData, 0)
        store.commit('updateVisitorData', visitorData)
        return visitorData
    }

    let params = { terminalType: 1, visitorId: storedVisitorData?.visitorId } // 1-PC官网，2-移动官网
    let visitorData = storedVisitorData

    if (!visitorData || getVi) {
        visitorData = await fetchAndStoreVisitorInfo(params)
        if (!visitorData) {
            console.warn('获取访客信息失败')
            next()
            return
        }
    }

    try {
        await otherAPI.addPVCount({ page: to.path }) // 添加PV数量(全局)
    } catch (error) {
        console.warn('添加PV统计失败:', error)
    }

    const currentUnisysid = getUnisysid()
    //判断缓存 防止重复调用
    if (currentUnisysid) {
        const storedProduct = store.state.sourceProduct

        if (!storedProduct || storedProduct.uniSysId !== currentUnisysid) {
            try {
                const res = await system.getProductInfo({ uniSysId: currentUnisysid })

                if (res.code === 200) {
                    store.commit('setSourceProduct', res.data)
                }
            } catch (error) {
                console.warn('获取产品信息失败:', error)
                if (store.state.sourceProduct) {
                    store.commit('setSourceProduct', null)
                }
            }

        }
    } else {
        // 如果没有 uniSysId，清空之前的来源项目信息
        if (store.state.sourceProduct) {
            store.commit('setSourceProduct', null)
        }
    }

    routerList.map((item) => {
        if (item == to.path) {
            store.commit('changeActiveIndex', '')
            VueCookies.set('activeIndex', '')
        }
    })

    // 如果要访问的是登录页则直接放行
    // if (to.path == '/login' || to.path == '/uni_login' || to.path == '/uni_web_login') return next()

    // // 获取token
    // const tokenStr = VueCookies.get('token')

    // // 如果没有token则代表当前尚未登录，强制跳转到登录页
    // if (!tokenStr) return next('/uni_web_login')

    // 如果没有被强制跳转到登录页，则放行到目标页
    next()
})

export default router
